document.addEventListener('DOMContentLoaded', () => {
  const videoWidgets = document.querySelectorAll('.js-video-widget');

  videoWidgets.forEach((videoWidget) => {
    const iframe = videoWidget.querySelector('iframe');
    const container = videoWidget.querySelector('.video-widget__container');
    const clickableArea = videoWidget.querySelector('.video-widget__placeholder-content');

    if (clickableArea) {
      clickableArea.addEventListener('click', () => {
        var iframeSrc = iframe.src;

        if (iframeSrc.includes('?')) {
          iframeSrc += '&autoplay=1';
        } else {
          iframeSrc += '?autoplay=1';
        }

        iframe.src = iframeSrc;
        container.classList.add('showVideo');
      });
    }
  });
});
